import * as React from "react";

function SvgAwsKinesis(props, ref) {
  return (
    <svg
      height="1em"
      viewBox="0 0 79.732 96"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none">
        <path
          d="M0 53.597l39.79 18.316 39.788-18.316-39.789-1.649z"
          fill="#fcbf92"
        />
        <path d="M39.911 0L.018 19.896v28.073h47.836V3.97z" fill="#9d5025" />
        <path
          d="M.018 67.76L39.935 96 79.73 67.76l-39.883-5.804z"
          fill="#fcbf92"
        />
        <g fill="#9d5025">
          <path d="M39.911 47.969h21.047V18.013l-6.146-2.458-14.9 4.346z" />
          <path d="M54.812 47.969H71.08v-19.43l-4.653-1.396-11.615 1.972z" />
          <path d="M66.427 25.62v22.349h13.15l.155-22.448-3.995-1.596z" />
        </g>
        <path
          d="M39.911 0v47.969h7.943V3.97zm21.047 18.013l-6.146-2.458v32.414h6.146zM71.08 28.539l-4.653-1.396V47.97h4.653zm4.657 19.43h3.994V25.52l-3.994-1.596zM39.79 57.576v14.337l39.788-9.918v-8.398zm0 24.268V96l39.94-19.97v-8.27z"
          fill="#f68534"
        />
        <path
          d="M.018 76.116L39.79 96V81.74L.02 67.759zM0 61.995l39.79 9.918V57.576L0 53.596z"
          fill="#9d5025"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAwsKinesis);
